export default {
  async resetState (context) {
    context.commit('appElement/reset')
    context.commit('applicationAppointment/reset')
    context.commit('applicationCustomer/reset')
    context.commit('applicationFieldTracking/reset')
    context.commit('applicationIncome/reset')
    context.commit('applicationMarital/reset')
    context.commit('applicationRetailStore/reset')
    context.commit('applicationSession/reset')
    context.commit('applicationVehicle/reset')
    context.commit('brands/reset')
    context.commit('cards/reset')
    context.commit('config/reset')
    context.commit('customer/reset')
    context.commit('display/reset')
    context.commit('loans/reset')
    context.commit('offers/reset')
    context.commit('origination/reset')
    context.commit('payment/reset')
    context.commit('referral/reset')
    context.commit('session/reset')
    context.commit('store/reset')
  }
}
